/**
 * Admin Slack Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  BackfillSlackBotBodySchema,
  BackfillSlackBotResponseSchema,
  SlackMigrationBotSchema,
  SlackMigrationStatusResponseSchema
} from "./schemas/slack-migration.schemas";

export const ZAdminSlackMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/slack/status",
    Response: ApiSuccessSchema(SlackMigrationStatusResponseSchema)
  },
  Backfill: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/slack/backfill",
    Body: BackfillSlackBotBodySchema,
    Response: ApiSuccessSchema(BackfillSlackBotResponseSchema)
  }
} as const;

export type TApiAdminSlackMigration = InferSchemas<typeof ZAdminSlackMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type SlackMigrationBot = z.infer<typeof SlackMigrationBotSchema>;
export type SlackMigrationStatusResponse = z.infer<typeof SlackMigrationStatusResponseSchema>;
